import React, { useState,useEffect } from "react";
import logoreceta from "../../../../assets/logorecetaspredeterminado.jpg";
import { getMedicoAuth ,getPerfilMedico} from "../../../../services/usuarios";
import "./PreviewReceta.css";
import { signosConfigurables } from "../../Recetas electronicas/RecetaConfig";

const PreviewReceta = ({ config, camposConfigurables, setConfig, paciente_id, diagnostico, tratamiento, medicamentos, fecha, nombrePaciente, digitalON, edad_en_emision, fecha_nacimiento_en_emision, signos_vitales_snapshot, }) => {
  
  const [medico, setMedico] = useState(null);
  const isDigital = digitalON === true;
  const ancho = isDigital ? 21.59 : config.anchoPersonalizado;
  const alto = isDigital ? 27.94 : config.altoPersonalizado;
  useEffect(() => {
    const cargarMedico = async () => {
      try {
        const medico = await getMedicoAuth();
        const perfilExtendido = await getPerfilMedico();
        if (medico && perfilExtendido) {
          const medicoCompleto = {
            ...medico,
            ...perfilExtendido,
          };
          setMedico(medicoCompleto);
        }
      } catch (error) {
        console.error("Error cargando datos del médico:", error);
      }
    };
  
    cargarMedico();
  
    const handleMessage = (event) => {
      if (event.data?.type === "refreshPreviewReceta" && event.data.paciente_id) {
        setConfig((prevConfig) => ({
          ...prevConfig,
          paciente_id: event.data.paciente_id,
        }));
      }
    };
  
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [setConfig]);
  
  const medsList = Array.isArray(medicamentos) ? medicamentos : [];
  const medsClean = medsList.filter(m =>
    (m?.nombre || "").trim() || (m?.indicaciones || "").trim()
  );
  const hasMeds = medsClean.length > 0;
  const mostrarEtiqueta = (labelKey) =>
  !labelKey || config[labelKey] !== false;  

  return (
    <div className="preview-container"
      style={{
        overflowX: config.zoom > 0.8 ? "auto" : "hidden",
        overflowY: "auto",
      }}
    >
      <h3>Receta Electrónica</h3>
      <div className="seccion-zoom">
        <h3>Zoom</h3>
        <input
          type="range"
          min="0.5"
          max="1"
          step="0.1"
          value={config.zoom}
          onChange={(e) =>
            setConfig((prev) => ({ ...prev, zoom: parseFloat(e.target.value) }))
          }
        />
        <span>{Math.round(config.zoom * 100)}%</span>
      </div>
      <div
        className="preview-receta"
        style={{
          width: `${ancho}cm`,
          height: `${alto}cm`,
          padding: `${config.margenSuperior}cm ${config.margenDerecho}cm ${config.margenInferior}cm ${config.margenIzquierdo}cm`,
          textAlign: config.alineacion,
          transform: `scale(${config.zoom})`,
          transformOrigin: "top left",
        }}
      >
        {config.mostrarImagen && (
          <img
           src={config.urlImagenPersonalizada 
             ? `${process.env.REACT_APP_BACKEND_URL}${config.urlImagenPersonalizada}` 
              : logoreceta}
            alt="Logo Receta"
            style={{
              position: "relative",
              left: `${config.margenXImagen}cm`,
              top: `${config.margenYImagen}cm`,
              width: `${config.anchoImagen}cm`,
              height: `${config.altoImagen}cm`,
            }}
          />
        )}
        {/* Textos libres personalizados */}
          {Array.isArray(config.textosLibres) &&
            config.textosLibres
              .filter((item) => item?.texto?.trim())
              .map((item) => (
                <div
                  key={item.id}
                  className="texto-libre-preview"
                  style={{
                    "--texto-x": `${Number(item.margenX) || 0}cm`,
                    "--texto-y": `${Number(item.margenY) || 0}cm`,
                    "--texto-color": item.color || "#000000",
                    "--texto-size": `${Number(item.tamañoLetra) || 12}pt`,
                    "--texto-font": item.fuente || "Arial",
                    "--texto-weight": item.bold ? "700" : "400",
                  }}
                >
                  {item.texto}
                </div>
              ))}
        <div className="detalles-medico">
          {camposConfigurables
            .filter((campo) => 
              ["mostrarNombreClinica", "mostrarNombre", "mostrarEscuela", "mostrarComentarios", 
              "mostrarTituloUniversitario", "mostrarEspecialidad", "mostrarCedulas", 
              "mostrarCedulaEspecialidad", "mostrarDireccion", "mostrarTelefonoCelular"]
              .includes(campo.fieldKey) // 🔹 Filtra solo los campos médicos
            )
            .map((campo, index) => {
              if (config[campo.fieldKey]) {
                const valorMostrado =
                  campo.fieldKey === "mostrarNombreClinica"
                    ? medico
                      ? medico.nombre_clinica || "Actualizar en configuración > Gestión de perfil"
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarNombre"
                    ? medico
                      ? `${medico?.sexo === "Femenino" || medico?.sexo === "Mujer" ? "Dra." : "Dr."} ${medico.nombre || ""} ${medico.apellido_paterno || ""} ${medico.apellido_materno || ""}`.trim() || "Actualizar en configuración > Gestión de perfil"
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarEscuela"
                    ? medico
                      ? medico.escuela_licenciatura
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarComentarios"
                    ? medico
                      ? medico.comentarios || "Actualizar en configuración > Gestión de perfil"
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarTituloUniversitario"
                    ? medico
                      ? medico.titulo_universitario
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarEspecialidad"
                    ? medico
                      ? medico.especialidad
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarCedulas"
                    ? medico
                      ? `${mostrarEtiqueta(campo.labelKey) ? "Cédula Profesional: " : ""}${medico.cedula_profesional || ""}`
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarCedulaEspecialidad"
                    ? medico
                      ? `${mostrarEtiqueta(campo.labelKey) ? "Cédula Especialidad: " : ""}${medico.cedula_especialidad || ""}`
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarDireccion"
                    ? medico
                      ? `${medico.direccion.calle}, ${medico.direccion.colonia}, ${medico.direccion.ciudad}, ${medico.direccion.estado}`
                      : "Actualizar en configuración > Gestión de perfil"
                    : campo.fieldKey === "mostrarTelefonoCelular"
                    ? medico
                      ? `${mostrarEtiqueta(campo.labelKey) ? "Cel: " : ""}${medico.telefono || ""}`
                      : "Actualizar en configuración > Gestión de perfil"
                    : ""; // 🔹 Ya no hay "1", si no está en la lista, devuelve vacío

                return (
                  <p
                    key={index}
                    style={{
                      position: "relative",
                      left: `${config[campo.marginXKey]}cm`,
                      top: `${config[campo.marginYKey]}cm`,
                      color: config[campo.colorKey],
                      fontSize: `${config[campo.sizeKey]}pt`,
                      fontFamily: config[campo.fontKey],
                      fontWeight: config[campo.boldKey] ? "bold" : "normal",
                    }}
                  >
                    {valorMostrado}
                  </p>
                );
              }
              return null;
            })}
        </div>

        {config.mostrarLineaSuperior && (
          <hr
            style={{
              position: "relative",
              width: `${config.longitudLineaSuperior}cm`,
              height: `${config.grosorLineaSuperior}px`,
              backgroundColor: config.colorLineaSuperior,
              border: "none",
              borderTop: `${config.grosorLineaSuperior}px solid ${config.colorLineaSuperior}`,
              marginLeft: `${config.margenXLineaSuperior}cm`,
              marginTop: `${config.margenYLineaSuperior}cm`,
            }}
          />
        )}

        {config.mostrarFecha && (
          <div className="detalles-fecha">
            <p
              style={{
                position: "relative",
                left: `${config.margenXFecha}cm`,
                top: `${config.margenYFecha}cm`,
                color: config.colorFecha,
                fontSize: `${config.tamañoLetraFecha}pt`,
                fontFamily: config.fuenteFecha,
                fontWeight: config.boldFecha ? "bold" : "normal",
              }}
            >
              {config.mostrarEtiquetaFecha !== false && (
                <>
                  <strong>Fecha:</strong>{" "}
                </>
              )}
              {(() => {
                if (!fecha) return new Date().toLocaleDateString("es-MX");

                // si viene en ISO yyyy-mm-dd → convertir a dd/mm/yyyy
                const [year, month, day] = fecha.split("-");
                return `${day}/${month}/${year}`;
              })()}
            </p>
          </div>
        )}

        
        {/* Renderizado de Edad y Signos Vitales */}
        <div className="detalles-clinicos">
          {camposConfigurables
            .filter((campo) =>
              ["mostrarEdad","mostrarFechaNacimiento", "mostrarSignos"].includes(campo.fieldKey)
            )
            .map((campo, index) => {
              if (config[campo.fieldKey]) {

                // 📌 Placeholders individuales (se vuelven dinámicos)
                const dummy = {
                  sistolica: "120P",
                  diastolica: "80P",
                  frecuencia_cardiaca: "80P",
                  frecuencia_respiratoria: "18P",
                  temperatura: "36.7P",
                  saturacion_oxigeno: "98P",
                  peso: "70P",
                  altura: "1.70P",
                  imc: "24.2P",
                  categoria_imc: "NormalP",
                };

                let valorMostrado;

                // ===============================
                //  CASO 1: Edad
                // ===============================
                if (campo.fieldKey === "mostrarEdad") {
                  const edadValor =
                    edad_en_emision ?? config.edad_en_emision ?? "";

                  const edadEtiqueta =
                    config.edad_etiqueta_en_emision || "ninguna";

                  if (edadValor === "" || edadValor === null) {
                    valorMostrado = "35 años (Texto de prueba)";
                  } else if (edadEtiqueta === "meses") {
                    valorMostrado = `${edadValor} meses`;
                  } else if (edadEtiqueta === "anios") {
                    valorMostrado = `${edadValor} años`;
                  } else {
                    valorMostrado = `${edadValor}`;
                  }
                }

                // ===============================
                //  CASO 2: Fecha de nacimiento
                // ===============================

                 else if (campo.fieldKey === "mostrarFechaNacimiento") {
                  let f = fecha_nacimiento_en_emision;

                    if (f) {
                      // Convertir yyyy-mm-dd a dd/mm/yyyy
                      const [year, month, day] = f.split("-");
                      valorMostrado = `${day}/${month}/${year}`;
                    } else {
                      valorMostrado = "01/01/1990 (Texto de prueba)";
                    }
                  }

                // ===============================
                //  CASO 3: Signos Vitales
                // ===============================
                else if (campo.fieldKey === "mostrarSignos") {

                  const s =
                    signos_vitales_snapshot &&
                    typeof signos_vitales_snapshot === "object"
                      ? signos_vitales_snapshot
                      : dummy;

                  const mostrarEtiquetasInternas =
                    config.mostrarEtiquetasInternasSignos !== false;

                  // Valor puro de cada signo.
                  // Las unidades se conservan aunque se quite la etiqueta interna.
                  const valoresSignos = {
                    mostrarTA:
                      s.sistolica && s.diastolica
                        ? `${s.sistolica}/${s.diastolica}`
                        : "(prueba)",

                    mostrarFC:
                      s.frecuencia_cardiaca
                        ? `${s.frecuencia_cardiaca} lpm`
                        : "(prueba)",

                    mostrarFR:
                      s.frecuencia_respiratoria
                        ? `${s.frecuencia_respiratoria} rpm`
                        : "(prueba)",

                    mostrarTemp:
                      s.temperatura
                        ? `${s.temperatura}°C`
                        : "(prueba)",

                    mostrarSpO2:
                      s.saturacion_oxigeno
                        ? `${s.saturacion_oxigeno}%`
                        : "(prueba)",

                    mostrarPeso:
                      s.peso
                        ? `${s.peso} kg`
                        : "(prueba)",

                    mostrarTalla:
                      s.altura
                        ? `${s.altura} m`
                        : "(prueba)",

                    mostrarIMC:
                      s.imc
                        ? `${s.imc}`
                        : "(prueba)",

                    mostrarClasificacionIMC:
                      s.categoria_imc
                        ? `${s.categoria_imc}`
                        : "(prueba)",
                  };

                  const signosActivos = signosConfigurables
                    .filter((signo) => config[signo.visibleKey] !== false)
                    .map((signo) => {
                      const separadorEtiqueta =
                        signo.visibleKey === "mostrarClasificacionIMC"
                          ? ": "
                          : " ";

                      return {
                        ...signo,
                        texto: `${
                          mostrarEtiquetasInternas
                            ? `${signo.label}${separadorEtiqueta}`
                            : ""
                        }${valoresSignos[signo.visibleKey]}`,
                      };
                    });

                  // =====================================
                  // POSICIÓN INDIVIDUAL
                  // =====================================
                  if (
                    (config.modoDistribucionSignos || "prosa") === "individual"
                  ) {
                    return (
                      <div
                        key={index}
                        className="signos-individuales-preview"
                        style={{
                          position: "relative",
                          left: `${config[campo.marginXKey]}cm`,
                          top: `${config[campo.marginYKey]}cm`,
                          color: config[campo.colorKey],
                          fontSize: `${config[campo.sizeKey]}pt`,
                          fontFamily: config[campo.fontKey],
                          fontWeight: config[campo.boldKey]
                            ? "bold"
                            : "normal",
                        }}
                      >
                        {mostrarEtiqueta(campo.labelKey) && (
                          <div className="etiqueta-general-signos-preview">
                            <strong>Signos Vitales:</strong>
                          </div>
                        )}

                        <div className="signos-individuales-contenido">
                          {signosActivos.map((signo) => (
                            <div
                              key={signo.visibleKey}
                              className="signo-individual-preview"
                              style={{
                                left: `${
                                  Number(config[signo.xKey]) || 0
                                }cm`,
                                top: `${
                                  Number(config[signo.yKey]) || 0
                                }cm`,
                              }}
                            >
                              {signo.texto}
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  }

                  // =====================================
                  // EN LÍNEA / PROSA
                  // Conserva exactamente las comas
                  // =====================================
                  valorMostrado = signosActivos
                    .map((signo) => signo.texto)
                    .join(", ");
                }

                return (
                  <p
                    key={index}
                    style={{
                      position: "relative",
                      left: `${config[campo.marginXKey]}cm`,
                      top: `${config[campo.marginYKey]}cm`,
                      color: config[campo.colorKey],
                      fontSize: `${config[campo.sizeKey]}pt`,
                      fontFamily: config[campo.fontKey],
                      fontWeight: config[campo.boldKey] ? "bold" : "normal",
                    }}
                  >
                    {mostrarEtiqueta(campo.labelKey) && (
                        <>
                          <strong>{campo.label.replace(" del Paciente", "")}:</strong>{" "}
                        </>
                      )}
                      {valorMostrado}
                  </p>
                );
              }

              return null;
            })}
        </div>

        {config.mostrarMarcaAgua && (
          <img
            src={config.urlImagenPersonalizada 
               ? `${process.env.REACT_APP_BACKEND_URL}${config.urlImagenPersonalizada}` 
              : logoreceta}
            alt="Marca de Agua"
            style={{
              position: "relative",
              zIndex: -1,
              left: `${config.margenXMarcaAgua}cm`,
              top: `${config.margenYMarcaAgua}cm`,
              width: `${config.anchoMarcaAgua}cm`,
              height: `${config.altoMarcaAgua}cm`,
              opacity: 0.08,
            }}
          />
        )}

        {config.mostrarLineaInferior && (
          <hr
            style={{
              position: "relative",
              width: `${config.longitudLineaInferior}cm`,
              height: `${config.grosorLineaInferior}px`,
              backgroundColor: config.colorLineaInferior,
              border: "none",
              borderTop: `${config.grosorLineaInferior}px solid ${config.colorLineaInferior}`,
              marginLeft: `${config.margenXLineaInferior}cm`,
              marginTop: `${config.margenYLineaInferior}cm`,
            }}
          />
        )}
        
        {/* Es la firma en imagen o la firma en texto y la linea, con esto ya no tocamos backend variables que se guardan porque ocupan las mismas, solo backend para guardar el .jpg y el .png */}
        {config.mostrarFirma && (
          <div className="firma-receta">

            {/* Si subió imagen de firma → solo mostrar imagen */}
            {config.urlFirmaPersonalizada ? (
              <img 
                src={`${process.env.REACT_APP_BACKEND_URL}${config.urlFirmaPersonalizada}`}
                alt="Firma"
                style={{
                  marginLeft: `${config.margenXFirma}cm`,
                  marginTop: `${config.margenYFirma-2.5}cm`,
                  width: "auto",
                  height: "2cm",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            ) : (
              /* Si no hay imagen → mostrar texto Firma */
              <p
                style={{
                  marginLeft: `${config.margenXFirma}cm`,
                  marginTop: `${config.margenYFirma}cm`,
                  color: config.colorFirma,
                  fontSize: `${config.tamañoLetraFirma}pt`,
                  fontFamily: config.fuenteFirma,
                  fontWeight: config.boldFirma ? "bold" : "normal",
                }}
              >
                Firma
              </p>
            )}

          </div>
        )}

        {/* Renderizado de Nombre del Paciente, Diagnóstico y Tratamiento */}
        <div className="detalles-paciente">
          {camposConfigurables
            .filter((campo) => 
              ["mostrarNombrePaciente", "mostrarDiagnostico", "mostrarTratamiento"].includes(campo.fieldKey) 
            )
            .map((campo, index) => {
              if (config[campo.fieldKey]) { // 🔹 Solo se muestra si está activado en la configuración
                const placeholders = {
                  mostrarNombrePaciente: "Juan López (Texto de prueba, agregue paciente y cambie el input)",
                  mostrarDiagnostico: "Hipertensión arterial (Texto de prueba, agregue paciente y cambie el input)",
                  mostrarTratamiento: "Tomar 1 comprimido de Enalapril cada 12 horas.\nAcudir a revisión en 7 días. (Texto de prueba, agregue paciente y cambie el input)",
                };

                // 📌 Asignar la información correcta según el campo
                let valorMostrado;
          if (campo.fieldKey === "mostrarNombrePaciente") {
              valorMostrado = nombrePaciente || config.nombrePaciente || placeholders.mostrarNombrePaciente;
            } else if (campo.fieldKey === "mostrarDiagnostico") {
              valorMostrado = diagnostico || config.diagnostico || placeholders.mostrarDiagnostico;
            } else if (campo.fieldKey === "mostrarTratamiento") {
              // Regla de prioridad:
              // 1) Si hay medicamentos con texto -> lista numerada (se renderiza abajo, no usamos valorMostrado)
              // 2) Si NO hay meds pero sí tratamiento (legacy) -> muestra tratamiento
              // 3) Si no hay nada -> placeholder
              const textoTratamiento = (tratamiento || config.tratamiento || "").trim();
              if (!hasMeds && textoTratamiento) {
                valorMostrado = textoTratamiento;
              } else if (!hasMeds && !textoTratamiento) {
                valorMostrado = placeholders.mostrarTratamiento;
              } else {
                valorMostrado = null; // cuando hay meds, no usamos valorMostrado
              }
            } else {
              valorMostrado = config[campo.fieldKey] || placeholders[campo.fieldKey];
            }

            // Si el campo es "mostrarTratamiento" y HAY medicamentos, renderizamos la lista numerada en la misma posición
                if (campo.fieldKey === "mostrarTratamiento") {
                  const textoPlan = (tratamiento || config.tratamiento || "").trim();
                    
                  if (hasMeds || textoPlan) {
                    return (
                      <div
                        key={index}
                        style={{
                          position: "relative",
                          left: `${config[campo.marginXKey]}cm`,
                          top: `${config[campo.marginYKey]}cm`,
                          color: config[campo.colorKey],
                          fontSize: `${config[campo.sizeKey]}pt`,
                          fontFamily: config[campo.fontKey],
                          fontWeight: config[campo.boldKey] ? "bold" : "normal",
                          width: `${ancho}cm`,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                        }}
                      >
                        {config.mostrarEtiquetaTratamiento !== false && (
                          <strong>Tratamiento:</strong>
                        )}

                        {hasMeds && (
                          <ol style={{ margin: 0, paddingLeft: 18 }}>
                            {medsClean.map((m, idx2) => {
                              const n = (m?.nombre || "").trim();
                              const i = (m?.indicaciones || "").trim();
                              return (
                                <li key={idx2} style={{ marginBottom: 2 }}>
                                  {n}{i ? ` — ${i}` : ""}
                                </li>
                              );
                            })}
                          </ol>
                        )}

                        {textoPlan && (
                          <div style={{ marginTop: hasMeds ? 6 : 0 }}>
                            {textoPlan}
                          </div>
                        )}
                      </div>
                    );
                  }

                  return (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        left: `${config[campo.marginXKey]}cm`,
                        top: `${config[campo.marginYKey]}cm`,
                        color: config[campo.colorKey],
                        fontSize: `${config[campo.sizeKey]}pt`,
                        fontFamily: config[campo.fontKey],
                        fontWeight: config[campo.boldKey] ? "bold" : "normal",
                        width: `${ancho}cm`,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {config.mostrarEtiquetaTratamiento !== false && (
                        <strong>Tratamiento:</strong>
                      )}
                      {placeholders.mostrarTratamiento}
                    </div>
                  );
                }

                return (
                  <p
                    key={index}
                    style={{
                      position: "relative",
                      left: `${config[campo.marginXKey]}cm`,
                      top: `${config[campo.marginYKey]}cm`,
                      color: config[campo.colorKey],
                      fontSize: `${config[campo.sizeKey]}pt`,
                      fontFamily: config[campo.fontKey],
                      fontWeight: config[campo.boldKey] ? "bold" : "normal",
                       width: `${ancho }cm`,      // límite real del texto
                       whiteSpace: "normal",         // habilita wrapping
                       wordBreak: "break-word",      // rompe palabras muy largas
                    }}
                  >
                    {mostrarEtiqueta(campo.labelKey) && (
                        <>
                          <strong>
                            {campo.label.replace(" del Paciente (Obligatorio)", "")}:
                          </strong>{" "}
                        </>
                      )}
                      {valorMostrado}
                  </p>
                );
              }
              return null;
            })}
        </div>
      </div>
    </div>
  );
};

export default PreviewReceta;
